import { ISharedItemProvider } from "@/Portal/Services/ISharedItemProvider";

class PrivateBillSharedItemProvider implements ISharedItemProvider {
    public getSharedItemTypeLabel(): string {
        return cacheStore.GetString("InvoiceLabel");
    }

    public getItemIconClass(): string {
        return "billingInvoiceIcon";
    }

    public shouldShowFilePreviewInPortfolio(): boolean {
        return true;
    }

    public createSendMedicalNoteItemToPortalPopupStrategy(): null {
        return null;
    }

    public getPinFrequencyToken(): string {
        return "";
    }

    public getPinFrequencyDocumentType(): null {
        return null;
    }
}

export { PrivateBillSharedItemProvider };
